export function fetchCurrentLocation(): Promise<{
  latitude: number;
  longitude: number;
  location: string;
}> {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const geocoder = new (window as any).google.maps.Geocoder();

        geocoder.geocode(
          {
            location: {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          },
          (results, status) => {
            if (status === 'OK') {
              results.forEach((result) => {
                if (result.types.includes('administrative_area_level_2')) {
                  resolve({
                    location: result.formatted_address,
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                  });
                }
              });

              reject(new Error('No results found.'));
            } else {
              reject(new Error(`Geocoder failed due to: ${status}`));
            }
          }
        );
      },
      (error) => {
        reject(error);
      }
    );
  });
}
